(function ($) {

  const initializeBlock = function ($block) {
    function getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }

    // const plyrOptions = {
    //   iconUrl: '/wp-content/themes/essensys/dist/img/video-play.svg'
    // };

    var id = getRandomInt(1000)
    const player = new Plyr($block.find('video'))

  }

  $(document).ready(function () {
    $('.block--full-video').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=full-video', initializeBlock);
  }

})(jQuery);